var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCloseNotification = function SvgIconCloseNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2D2C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 14 7.5 7.5M1 1l6.5 6.5m0 0L14 1M7.5 7.5 1 14"
  })));
};
export { SvgIconCloseNotification as ReactComponent };
export default __webpack_public_path__ + "images/Icon_Close_Notification.svg";